import { gql } from '@apollo/client'

import cardProfile from './cardProfileFragment'
import parsedShortcodes from './parsedShortcodesFragment'

const blogPostFragment = gql`
  fragment blogPost on Market {
    blogPost(slug: $slug) {
      slug
      image {
        url
      }
      videos {
        url(preset: VIDEO_DEFAULT)
      }
      title
      excerpt
      postContent
      profiles {
        ...cardProfile
      }
      updatedAt
      ...parsedShortcodes
      category {
        title
        slug
      }
    }
  }
  ${cardProfile}
  ${parsedShortcodes}
`

export default blogPostFragment
